import classNames from 'classnames';
import React from 'react';
import type { ReactChildren } from 'types/utility';
import styles from './InputHelpText.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children: ReactChildren;
  /** Show this text inline, after input? */
  inline?: boolean;
}

const InputHelpText: React.FC<Props> = ({ children, inline, ...rest }) => {
  const containerClass = classNames(styles.container, rest.className, {
    [styles.inline]: !!inline,
  });
  return (
    <div {...rest} className={containerClass}>
      {children}
    </div>
  );
};

InputHelpText.defaultProps = {};

export default InputHelpText;
